// Component
import { Faq } from './faq.component'

export default Faq
